export default __webpack_public_path__ + "static/media/Anamnesis questions-1731494398098.046c7a2b.png";